import React, { useState } from 'react';

function ScannerRcg({ onSubmit, notFound, loading }) {
    const [value, setValue] = useState('');

    const handleSubmit = () => {
        if (!value) return;
        onSubmit(value);
        setValue('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSubmit();
    };

    return (
        <>
            <div className={"scanner-rcg-banner"}>
                <div className={"scanner-rcg-banner-icon"}>
                    <i className={"fa fa-qrcode"}></i>
                </div>
                <div className={"scanner-rcg-banner-text"}>
                    <h4>Scanner un matériel</h4>
                    <p>Pointez le scanner sur le code-barres du matériel ou saisissez le code manuellement.</p>
                </div>
            </div>

            <div className={"scanner-rcg-input-wrapper"}>
                <i className={"fa fa-barcode scanner-rcg-input-icon"}></i>
                <input
                    type="text"
                    placeholder={"Code-barres du matériel"}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    disabled={loading}
                    autoFocus
                />
                <button
                    disabled={!value || loading}
                    onClick={handleSubmit}
                    className={"scanner-rcg-send-btn"}
                >
                    <i className={"fa fa-paper-plane"}></i>
                </button>
            </div>

            {notFound && (
                <p className={"red text-center mt_15"}>
                    <i className={"fa fa-exclamation-circle"}></i> Code-barres non conforme ou non reconnu
                </p>
            )}
        </>
    );
}

export { ScannerRcg };
